export const DEFAULTS = {
    loading: {
        form: false,
    },
};
